import { PageStatus } from '@tinct/core-api-models';

/**
 * The status to DISPLAY: the live generation-job state overrides the stored
 * page status. Structural param so both EmbeddedPage (non-null status) and
 * ReadPage (nullable status) callers keep their own nullability.
 */
export function getEffectiveStatus<T extends PageStatus | null>(page: {
  status: T;
  lastGenerationJob?: { status?: string | null } | null;
}): PageStatus | T {
  const jobStatus = page.lastGenerationJob?.status;
  if (jobStatus === 'running') return 'generating';
  if (jobStatus === 'queued') return 'queued';
  return page.status;
}
